import axios from "@/widgets/shared/utils/axios-instance";
import {entityIdsOf, entityMapOf} from "@/widgets/shared/utils/entity-utils";
import Constants from "@/widgets/shared/constants";

// Array of supported components by the app
// eslint-disable-next-line prettier/prettier
const componentTypes = [
  Constants.AGENDA_COMPONENT_TYPE,
  Constants.BUSINESS_MATCHING_COMPONENT_TYPE
];

export function state() {
  return {
    ids: [],
    components: {},
  };
}

export const mutations = {
  setComponents(state, components) {
    // Filter only for agenda and business matching components
    // Optimizes lookup times as other components are useless for the widget
    const agendaComponents = components
      .filter(component => componentTypes.includes(component.component_name))
      .sort((a, b) => a.order - b.order);

    state.ids = entityIdsOf(agendaComponents);
    state.components = entityMapOf(agendaComponents);
  },
};

export const actions = {
  async loadComponents({commit}, {eventId}) {
    const res = await axios.get(`/events/${eventId}/components`);
    commit("setComponents", res.data);
  },
};

export const getters = {
  componentById: state => id => state.components[id],

  allComponents(state, getters) {
    return state.ids.map(getters.componentById);
  },

  agendaComponents(state, getters) {
    const components = getters["allComponents"];
    return filterComponentsByType(components, Constants.AGENDA_COMPONENT_TYPE);
  },

  businessMatchingComponents(state, getters) {
    const components = getters["allComponents"];
    return filterComponentsByType(components, Constants.BUSINESS_MATCHING_COMPONENT_TYPE);
  },
};

function filterComponentsByType(components, type) {
  return components.filter(c => c.component_name === type);
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
